import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Container from 'components/helpers/Container';
import {
  TcDirectoryListingProps,
  PageHeader,
  AboutTab,
  OverAllSurvivalTab,
  NumberOfTransplantsTab,
  TransplantByDiseaseTab,
  AdditionalInfoTab,
  SurvivorshipProgramTab,
} from 'components/helpers/NmdpSite/TcDirectoryListing';
import TCDirectoryMeta from 'components/helpers/NmdpSite/TcDirectoryListing/TCDirectoryMeta';

import ReactTabs from 'components/helpers/Tabs/_ReactTabs';
import { classnames } from 'tailwindcss-classnames';
import { logInfo } from 'lib/util/errors';

const TcDirectoryListing = ({ fields, ...props }: TcDirectoryListingProps): React.JSX.Element => {
  // Fail out if we don't have any fields
  if (!fields) {
    return <MissingDataSource />;
  }
  logInfo('TC Directory listing id - ', fields.listing?.listingId?.value ?? -1);

  const tabs = [
    { name: 'About the center', component: <AboutTab fields={fields} {...props} /> },
    { name: 'Overall survival', component: <OverAllSurvivalTab fields={fields} {...props} /> },
    {
      name: 'Number of transplants',
      component: <NumberOfTransplantsTab fields={fields} {...props} />,
    },
    {
      name: 'Transplants by disease',
      component: <TransplantByDiseaseTab fields={fields} {...props} />,
    },
    { name: 'Additional info', component: <AdditionalInfoTab fields={fields} {...props} /> },
    {
      name: 'Survivorship program',
      component: <SurvivorshipProgramTab fields={fields} {...props} />,
    },
  ];
  const container = classnames(
    'max-w-screen-2xl',
    'mx-auto',
    'w-full',
    'block',
    'py-6',
    'px-4',
    'md:px-20',
    'md:py-12',
    'px-gutter-all',
    'overflow-hidden',
    'relative',
    'page-section',
    'theme-white',
    'bg-theme-bg',
    'text-solidBlack'
  );
  return (
    <Container
      size="standard"
      dataComponent="authorable/nmdpsite/tcdirectory"
      className={container}
    >
      <TCDirectoryMeta fields={fields} {...props} />
      <PageHeader fields={fields} {...props} />
      <ReactTabs tabs={tabs} />
    </Container>
  );
};

export default TcDirectoryListing;
